import React from 'react';
import { motion } from 'framer-motion';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';

const AuthPage = ({ mode = 'login' }) => {
  const isLogin = mode === 'login';

  return (
    <div className="h-screen bg-black flex overflow-hidden">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden flex-col justify-start">
        <img
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80"
          alt="Office"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 max-w-lg px-12 pt-10">
          <motion.img
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            src="/assets/images/avif/Copym-05-1.png"
            alt="COPYM"
            className="h-20 w-auto object-contain mb-10"
          />
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-white text-5xl font-bold leading-tight mb-4"
          >
            Invest in <span className="text-emerald-400">Tokenized</span>
            <br />
            Real-World Assets
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-gray-400 text-lg leading-relaxed"
          >
            Access fractional ownership of premium assets across real estate, commodities, art, and more — all secured on blockchain.
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
            className="mt-12 flex gap-8"
          >
            <div>
              <p className="text-white text-2xl font-bold">+70</p>
              <p className="text-gray-500 text-xs tracking-wider uppercase mt-1">Blockchains</p>
            </div>
            <div>
              <p className="text-white text-2xl font-bold">+5</p>
              <p className="text-gray-500 text-xs tracking-wider uppercase mt-1">Countries</p>
            </div>
            <div>
              <p className="text-white text-2xl font-bold">+3</p>
              <p className="text-gray-500 text-xs tracking-wider uppercase mt-1">Asset Classes</p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-8 bg-white overflow-y-auto no-scrollbar">
        <motion.div
          key={mode}
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          {isLogin ? <LoginPage /> : <SignupPage />}
        </motion.div>
      </div>
    </div>
  );
};

export default AuthPage;
